export enum NotificationType {
  CartNotification = 'CartNotification',
  FacilityNotification = 'FacilityNotification',
  DifferentProduct = 'DifferentProduct',
  UnhandledLicense = 'UnhandledLicense',
  None = 'None',
}
